module.exports = __webpack_public_path__ + "static/media/94140030-jLQ0wSgs.dfc8fd43.JPG";